<template>
      <select
            class="adi4i"
            :class="[size, status]"
            @change="$emit('input', $event.target.value)"
            @focus="$emit('focus')"
            @blur="$emit('blur')"
            :data-fup="`select/${id}`"
      >
            <option v-if="allowSelectNothing" :value="null">{{ placeholder }}</option>
            <option v-else :value="null" disabled selected hidden>
                  {{
                  placeholder
                  }}
            </option>
            <option
                  v-for="(option, i) in options"
                  :key="i"
                  :selected="option[valueKey] === value"
                  :value="option[valueKey]"
            >{{ option[nameKey] }}</option>
      </select>
</template>

<script>
export default {
	name: "j-base-select",

	props: {
		value: {
			validator(value) {
				return value === null || typeof value === "string"
			},
			required: true,
			default: null
		},
		options: {
			required: true,
			default: () => [],
			type: Array
		},
		size: {
			required: false,
			default: "medium",
			validator(val) {
				return (
					val === null ||
					[
						"xsmall",
						"small",
						"medium",
						"large",
						"xlarge"
					].includes(val)
				)
			}
		},
		status: {
			required: false,
			default: null,
			validator(val) {
				return (
					val === null ||
					["error", "success", "warning"].includes(val)
				)
			}
		},
		nameKey: {
			type: String,
			default: "name"
		},
		valueKey: {
			type: String,
			default: "value"
		},
		placeholder: {
			type: String,
			default: "----"
		},
		allowSelectNothing: {
			type: Boolean,
			required: false,
			default: true
		},
		readonly: {
			default: false
		},
		id: {
			type: String,
			required: false
		}
	}
}
</script>
<style src="./index.css" scoped />
